import { mapGetters } from "vuex";
import { store } from "@sim/store/store";
import api from "@sim/services/api";
import router from "@sim/router";
import localStorage from "@sim/services/storage";
import citizenship from "@checkout/services/citizenship";
import SingleStep from "@sim/components/Partials/SingleStep.vue";
import StepWrapper from "@sim/components/Partials/StepWrapper.vue";
import IntlPhone from "@checkout/components/Partials/IntlPhone.vue";
import stepsMixin from "@sim/mixins/stepsMixin";
import _ from "lodash";
import RadioInput from './Inputs/RadioInput.vue';
import { transformErrors } from '@checkout/services/errors';

export default {

  mixins: [stepsMixin],

  components: {
    SingleStep,
    StepWrapper,
    RadioInput,
    IntlPhone
  },

  data() {
    return {
      chosenMethod: '',
      form: {
        identifiedBy: "",
        idNo: "",
        issueDate: "",
        validUntil: "",
        issuer: "",
        mobilePhone: "",
        citizenship: "",
        token: "",
      },
      errors: [],
      citizenships: citizenship.data.countries,
      skipJumping: false,
      showFileMethods: [],
      prefix: localStorage.get('locale', true) ? '/'+localStorage.get('locale', true) : '/de',  
    };
  },

  computed: {
    ...mapGetters(["steps"]),

    isStep4() {
      return this.$route.meta.stepNumber === "4";
    },

    getIdentifiedByKeys() {
      return citizenship.getIdentifiedByKeys(
        this.form.citizenship,
        false
      );
    },
  },

  methods: {
    prepareStep4() {
      api
        .get("/public-api/prepare-sim/4/" + localStorage.get("page-step", true))
        .then((response) => {
          this.form.mobilePhone = response.data.user.mobilePhone;
          
          let token = localStorage.get("token", true);

          if (token !== null) {
            this.form.token = token;
          }
        })
        .catch((error) => {
          this.$swal(this.$i18nApi.t("messages.error"));
          router.push(this.prefix+"/sim-registration/1");
        });
    },

    updateCustomer: function () {
      store.commit("TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE");

      api.post('/public-api/update-sim-customer', this.form)
        .then((response) => {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
            
            router.push(this.prefix+"/sim-registration/5");
        })
        .catch(error => {
            store.commit('TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE');
            this.$swal(this.$i18nApi.t('messages.error'));
            if (error.response.status === 422) {
              this.errors = transformErrors(error.response.data.errors);
            }

            if (error.response.data.hasOwnProperty("error")) {
                this.$swal(this.$i18nApi.t("messages.error"));
            }
        });
    },
  },

  mounted() {
    this.prepareStep4();
  },
};
